import { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";

import Timer from "./Timer";

function SlideDisplay({
  slideUrl,
  isHidden,
  handleSlidePostMessage,
  currPollNumCompleted,
  discussPhase,
  timerTimes,
  setDisableArrowControls,
  handleNavigation,
  timerModalInfo,
  setTimerModalInfo,
  setIsGamePlaying,
  isTutorialTooltipBlockingInputs,
  completeActiveTutorial,
}) {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(true);
  }, [slideUrl]);

  const hideSpinner = () => {
    setIsLoading(false);
  };

  const containerStyle = isHidden
    ? {
        zIndex: -1,
        opacity: "0%",
      }
    : { zIndex: 1, opacity: "100%" };

  return (
    <div id="slides-container" style={containerStyle}>
      {isLoading && (
        <TailSpin
          wrapperClass="tailspin-loader"
          height={100}
          width={100}
          color="#8a8a8a"
        />
      )}
      <iframe
        id="slide-deck"
        src={slideUrl}
        title="Slide Deck"
        allow="autoplay"
        onLoad={() => {
          handleSlidePostMessage("configure", [
            {
              controls: false,
              slideNumber: false,
              progress: false,
              overview: false,
            },
          ]);
          hideSpinner();
        }}
        frameBorder="0"
        style={{ display: isLoading ? "none" : "block" }}
        tabIndex={-1}
      />
      {typeof currPollNumCompleted === "number" && (
        <div id="curr-poll-indicator-container">
          {/** @todo update color according to slide theme color */}
          <span id="curr-poll-number-completed">{currPollNumCompleted}</span>
        </div>
      )}
      {discussPhase && (
        <div id="timer-discuss-container" key={discussPhase}>
          <Timer
            type="discuss"
            phase={discussPhase}
            timerTimes={timerTimes}
            setDisableArrowControls={setDisableArrowControls}
            handleNavigation={handleNavigation}
            timerModalInfo={timerModalInfo}
            setTimerModalInfo={setTimerModalInfo}
            setIsGamePlaying={setIsGamePlaying}
            isTutorialTooltipBlockingInputs={isTutorialTooltipBlockingInputs}
            completeActiveTutorial={completeActiveTutorial}
          />
        </div>
      )}
    </div>
  );
}

export default SlideDisplay;
